import { useEffect } from "react";
import { useDispatch } from "react-redux";

import "../../assets/styles/components_styles/homePage.css";
import Header from "../../components/common/Layouts/Header";
import HelmetWrapper from "../../components/common/Layouts/HelmetWrapper";
import BannerSection from "../../components/Home/BannerSection";
import EventCategoriesSection from "../../components/Home/EventCategoriesSection";
import FeaturedEventsSection from "../../components/Home/FeaturedEventsSection";
import UpcomingEventsSection from "../../components/Home/UpcomingEventsSection";
import HostEventCTA from "../../components/Home/HostEventCTA";
import Footer from "../../components/common/Layouts/Footer";
import { fetchFeaturedEvents } from "../../redux/eventSlice";

export default function HomePage() {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchFeaturedEvents(12));
  }, [dispatch]);

  return (
    <>
      <HelmetWrapper 
        title="Pinginvite - The Go-To Platform for Local Events in Kolkata & Dubai" 
        description="Pingvite connects people with local events in Kolkata and Dubai through community focus, affordability, 
        and city-specific visibility for organizers and users." 
        keywords="Top Upcoming Events in Kolkata, Best Live Events in Kolkata, best upcoming events in Kolkata, 
        online events near you in Kolkata,  upcoming events in Kolkata, Events in Kolkata, Top Upcoming Events in Dubai, 
        Best Live Events in Dubai, best upcoming events in Dubai, online events near you in Dubai, Event calendar in Dubai, 
        Event tickets in Dubai, upcoming events in Dubai, Events in Dubai"
      />      
      <Header />
      <BannerSection />
      <EventCategoriesSection />
      <FeaturedEventsSection />
      <UpcomingEventsSection />
      <HostEventCTA />
      <Footer />
    </>
  );
}